import React from "react";
import PropTypes from "prop-types";
import Hero from "../Hero";
import Author from "../Post/Author";
import Footer from "../Footer";
import PostFooter from "../PostFooter";
const config = require("../../../content/meta/config");
import VisibilitySensor from "react-visibility-sensor";
import Comments from "../Post/Comments";

class Article extends React.Component {
  separator = React.createRef();

  state = {
    fixedFooter: true,
    showRelatedPosts: false
  };

  scrollToContent = e => {
    this.separator.current.scrollIntoView({ block: "start", behavior: "smooth" });
  };

  footerVisibilitySensorChange = val => {
    if (val) {
      this.setState({ fixedFooter: false });
    } else {
      this.setState({ fixedFooter: true });
    }
  };

  relatedPostsVisibilitySensorChange = val => {
    if (val) {
      this.setState({ showRelatedPosts: true });
    } else {
      this.setState({ showRelatedPosts: false });
    }
  };

  render() {
    const {
      children,
      theme,
      title,
      slug,
      cover,
      subtitle,
      tags,
      authorId,
      prev,
      next,
      date
    } = this.props;

    const postUrl = config.siteUrl + config.pathPrefix + slug;

    return (
      <React.Fragment>
        <Hero
          scrollToContent={this.scrollToContent}
          backgrounds={cover}
          theme={theme}
          title={title}
          subtitle={subtitle}
          tags={tags}
        />
        <hr ref={this.separator} />
        <VisibilitySensor onChange={this.footerVisibilitySensorChange}>
          <div className="sensor" />
        </VisibilitySensor>
        <article className="article">{children}</article>
        <VisibilitySensor onChange={this.relatedPostsVisibilitySensorChange}>
          <div className="sensorBottom" />
        </VisibilitySensor>
        {authorId ? <Author id={authorId} theme={theme} /> : null}
        {/*Use whether author ID exists to determine if this is a post footer*/}
        {authorId ? (
          <PostFooter
            fixed={this.state.fixedFooter}
            prev={prev}
            postTitle={title}
            postExcerpt={subtitle}
            postUrl={postUrl}
            postCover={cover}
            authorId={authorId}
            next={next}
            postDate={date}
            theme={theme}
            showRelatedPosts={this.state.showRelatedPosts}
          />
        ) : (
          <Footer config={config} theme={theme} />
        )}
        { authorId ? <Comments config={config} theme={theme} title={title} slug={slug}/> : null}

        {/* --- STYLES --- */}
        <style jsx>{`
          .article {
            padding: ${theme.space.inset.default};
            margin: 0 auto;
          }

          hr {
            margin: 0;
            border: 0;
          }

          .sensor {
            display: block;
            position: absolute;
            bottom: 0;
            z-index: 1;
            left: 0;
            right: 0;
            height: 1px;
            top: ${theme.header.height.default};
          }

          .sensorBottom {
            height: 1px;
          }

          @from-width tablet {
            .article {
              max-width: ${theme.text.maxWidth.tablet};
            }
          }
          @from-width desktop {
            .article {
              max-width: ${theme.text.maxWidth.desktop};
            }
          }
        `}</style>
      </React.Fragment>
    );
  }
}

Article.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.object.isRequired,
  cover: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  slug: PropTypes.string,
  date: PropTypes.string,
  authorId: PropTypes.string,
  subtitle: PropTypes.string,
  prev: PropTypes.object,
  next: PropTypes.object,
  tags: PropTypes.array
};

export default Article;
